export interface TimeZonesList {
    value: string;
    city: string;
    label: string;
    utc: string;
}

export function getTimeZonesList(): TimeZonesList[] {
  const timeZones =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (Intl as any).supportedValuesOf?.("timeZone") ?? ["UTC"];

  const getUtcOffset = (tz: string) => {
    const now = new Date();

    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: "shortOffset",
    });
    const parts = formatter.formatToParts(now);
    const offsetPart = parts.find((p) => p.type === "timeZoneName")?.value ?? "";

    const normalized = offsetPart
      .replace("GMT", "UTC")
      .replace("UTCUTC", "UTC")
      .replace(" ", "")
      .replace(/(\d)(?=[APM])/g, "$1 ");

    return normalized || "UTC+00:00";
  };

  return timeZones.map((tz: string) => {
    const parts = tz.split("/");
    let city = parts[1]?.replace(/_/g, " ") ?? tz;
    city = city.replace("_"," ");
   return {
    value: tz,
    city: city,
    label: `${city} ${getUtcOffset(tz)}`,
    utc: getUtcOffset(tz),
  }});
}

export const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const savedTimeZone = (() => {
  try {
    const raw = localStorage.getItem("timeZone");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
})();
